import breakpoints from '../services/breakpoints';
import screenUtil from '../utils/screen';
import {isObject} from "./object-util";

export function getValueFromThreshold(threshold: BreakpointOverridable<string | number>): number {
	const currentThreshold = isObject(threshold) ? getThresholdForBreakpoint(threshold) : threshold;

	return typeof currentThreshold === 'string' ? screenUtil.getScreenRatioValue(currentThreshold) : currentThreshold;
}

export function isValidThresholdValue(thresholdValue: string | number): boolean {
	if (typeof thresholdValue === 'string') {
		return /^[0-9]+%$/.test(thresholdValue);
	}

	if (typeof thresholdValue === 'number') {
		return !isNaN(thresholdValue) && thresholdValue >= 0;
	}

	return false;
}

function getThresholdForBreakpoint(threshold: Record<string, string | number>): string | number {
	const currentBp = breakpoints.getCurrentBreakpoint();

	return isValidThresholdValue(threshold[currentBp]) ? threshold[currentBp] : threshold.default;
}